import React, { useEffect } from "react";
import validator from "@rjsf/validator-ajv8";
import { Box, Button } from "@mui/material";
import { Form } from "@rjsf/mui";
// import schema from "./LabDetailsSchema.json";
import uischema from "./LabDetailsUiSchema.json";
import useLabDetailsSchemaFn from "./LabDetailsSchema";


function LabDetails({ autoPolulatedData }) {
  const removeSubmitButton = true;
  const schema = useLabDetailsSchemaFn()
  return (
    <div>
      <Box p={2} id="rjsf">
        <Form
          className="lab-details"
          schema={schema}
          validator={validator}
          uiSchema={uischema}
          formData={autoPolulatedData}
          children={removeSubmitButton || false}
        />
      </Box>
    </div>
  );
}

export default LabDetails;
